// 파트너센터 이용약관 문안 (2026-09-11) — 원본 docs/ops/policy/partner-terms/{common,rights,creator}.md (PR #387)
// 서명 모달(PartnerTermsModal)이 그리고, partnerHub.termsDocumentText() 가 이 문안을 그대로 해시한다.
//
// 🔒 규칙
//  * import 없음 — partnerDocs.js 와 같은 순수 파일. 회귀 테스트(partnerDocs.test.js)가 문안을 훑는다.
//  * 문안·체크 문구는 해시 대상이다. tt() 로 감싸지 않는다 — 언어에 따라 해시가 달라지면 같은 서명이 다른 문서가 된다.
//  * 문안을 고치면 그 문서의 version 을 올리고, 배포 뒤 어드민 「요구 버전」을 같은 값으로 올린다(번들 먼저 → 표).
//    서버 partner_program.terms_versions_required 기본값(마이그레이션 20260911100000)도 이 버전과 같아야 한다.
//  * 유형별 표준 비율 숫자(30·10·15)는 쓰지 않는다 — 비율은 개별 계약·본인 화면.
//  * sections 는 [제목, 본문] 튜플. 장 제목(제1장 …)은 본문 "" 인 튜플로 두고 화면은 소제목으로 그린다. 항은 \n 으로 잇는다.

export const TERMS_COMMON_KEY = "terms-common";
export const TERMS_RIGHTS_KEY = "terms-rights";
export const TERMS_CREATOR_KEY = "terms-creator";
export const TERMS_MARK_KEY = "terms-mark"; // 부속 C — 파트너 마크 사용 규정 (2026-09-22, 모든 유형 필수)

export const TERMS_DOCS = [
  {
    key: TERMS_COMMON_KEY,
    // v1.5 (2026-09-19 대표 결정): 수익쉐어 그림 확인(figureCheck — 2×2 표 + 별도 확인 1개) 추가. 조문은 그대로. 서버 partner_agreement_sign 이 share_matrix 항목을 요구한다(마이그레이션 20260919100000 — 번들 배포 뒤 적용).
    // 🔒 figureCheck 의 글자(칸 제목·설명·범례·확인 문구)는 해시 대상이고 화면(PartnerShareMatrix)이 **이 데이터를 그대로** 그린다 — 그림만 바꾸는 일이 없게. 유형별 표준 비율 숫자 금지(「자기 비율」로만).
    figureCheck: {
      key: "share_matrix",
      version: "1",
      title: "이 수익의 파트너 몫은 누구에게 가나요?",
      rowLabels: ["작품을 레이블리가 직접 계약", "작품을 영상권리사 파트너가 영업"],
      colLabels: ["크리에이터를 레이블리가 직접 모집", "크리에이터를 크리에이터 파트너가 유치"],
      cells: [
        { id: "none", row: 0, col: 0, title: "파트너 몫 없음", desc: "기본 구조 그대로 — 누구의 몫도 달라지지 않습니다.", bar: [["house", 1, "레이블리"]] },
        { id: "creator", row: 0, col: 1, title: "크리에이터 파트너 — 자기 비율 그대로", desc: "크리에이터 파트너가 유치한 크리에이터가 낸 수익입니다.", bar: [["marketing", 1, "자기 비율 전부"]] },
        { id: "video", row: 1, col: 0, title: "영상권리사 파트너 — 자기 비율 그대로", desc: "영상권리사 파트너가 영업한 권리사의 작품에서 난 수익입니다.", bar: [["video", 1, "자기 비율 전부"]] },
        { id: "overlap", row: 1, col: 1, hot: true, title: "둘이 만난 수익 — 각자 자기 비율의 절반", desc: "작품과 크리에이터 둘 다 있어야 생기는 수익입니다. 혼자였다면 없었을 수익의 절반입니다.", bar: [["video", 0.5, "자기 비율의 ½"], ["marketing", 0.5, "자기 비율의 ½"]] },
      ],
      notes: [
        "파트너 몫은 레이블리 매출 안의 조각 하나입니다. 크리에이터의 몫과 영상권리사의 몫은 어느 경우에도 파트너 몫 때문에 줄지 않습니다.",
        "같은 파트너가 작품과 크리에이터를 모두 데려온 수익에는 자기 비율을 한 번만 적용합니다. 상대 파트너의 비율과 이름은 제공하지 않습니다.",
      ],
      label: "위 표를 확인했습니다 — 두 유형의 파트너가 함께 만든 수익은 각자 자기 비율의 절반, 한쪽만 파트너이면 자기 비율 그대로, 둘 다 레이블리가 직접 데려온 경우에는 파트너 몫이 없습니다(제10조 제2항).",
    },
    version: "v1.6", // 2026-09-21 대표 결정 ⓕ: 제16조 1항 「실제 손해를 배상」→「법령이 정하는 범위에서 책임」, 2항 회사 책임 한도(12개월 수익쉐어·고의·중과실 제외)로 재서술 — 재서명 필요·공지 7일(docs/ops/partner-center-access-plan.md §8-4). 요구 버전(terms_versions_required)은 공지 뒤 어드민에서 올린다. 종전 v1.5(2026-09-19): 수익쉐어 그림 확인 추가. v1.4: 2026-09-11 쿠팡 파트너스 벤치마크 반영(R-2 기술적 부정행위 제8조 9호 · R-3 소명 절차·통지 코드 표기 제14조 · R-5 최소 지급액 이월 제11조 7항). 마이그레이션 20260911180000 이 요구 버전을 맞춘다. v1.3: 부칙 시행일(20260911170000)
    title: "파트너센터 이용약관 (공통)",
    short: "공통 약관",
    appliesTo: ["video", "marketing", "both"],
    intro: "이 문서는 모든 파트너가 서명합니다. 영상권리사 파트너는 부속 A, 크리에이터 파트너는 부속 B를 함께 서명하며, 둘 다인 파트너는 세 문서 모두 서명합니다. 부속이 이 문서와 다르게 정한 것은 부속이 우선합니다.",
    sections: [
      ["제1장 총칙", ""],
      ["제1조 (목적)", "이 약관은 주식회사 루나르트(이하 \"회사\")가 운영하는 레이블리의 파트너 프로그램과 파트너센터(이하 \"파트너센터\")를 이용하는 파트너와 회사 사이의 권리·의무와 절차를 정합니다. 파트너센터는 회사와 파트너 협약을 맺은 파트너가 레이블리에서 사용되는 영상 또는 레이블리를 이용하는 크리에이터를 대상으로 홍보·마케팅·영업을 협업할 때 필요한 정보와 기능, 서비스, 정산을 위해 운영됩니다."],
      ["제2조 (용어의 정의)", [
        "1. \"레이블리\"란 회사가 운영하는 웹사이트·모바일 애플리케이션과 그 서비스를 말합니다.",
        "2. \"파트너\"란 이 약관에 동의하고 회사가 파트너 계정을 부여한 개인 또는 사업자를 말하며, 파트너센터에서 본인이 선언하고 회사가 확인한 유형에 따라 다음으로 구분합니다. ㈎ 영상권리사 파트너 — 영상권리사(방송사·제작사·OTT 등)를 발굴해 작품 제공 계약으로 잇는 파트너(부속 A 적용) ㈏ 크리에이터 파트너 — 크리에이터를 모집해 가입·채널 승인까지 잇는 파트너(부속 B 적용) ㈐ 두 활동을 모두 하는 파트너(부속 A·B 모두 적용).",
        "3. \"회원\"이란 레이블리 이용약관에 따라 회사가 가입을 승인한 크리에이터 회원과 영상권리사 회원을 말합니다.",
        "4. \"실적\"이란 이 약관·부속·개별 계약이 정한 절차를 거쳐 회사가 파트너의 소개로 인정한 회원 가입 또는 영상권리사 거래를 말합니다.",
        "5. \"수익쉐어\"란 실적에서 발생한 회사의 매출 중 개별 계약 또는 파트너센터 본인 화면에 표시된 비율에 따라 파트너에게 지급하는 금액을 말합니다.",
        "6. \"개별 계약\"이란 회사와 파트너가 이 약관과 별도로 체결한 협약서·계약서·부속합의서를 말합니다.",
        "7. \"교육\"이란 회사가 파트너센터에서 제공하는 수료 튜토리얼과 그 갱신분을 말합니다.",
      ].join("\n")],
      ["제3조 (약관의 효력, 변경, 개별 계약과의 관계)", [
        "1. 이 약관과 부속은 파트너가 파트너센터에서 내용을 확인하고 전자적으로 동의(서명)한 때 효력이 생깁니다. 파트너와 회사는 이 전자적 동의를 「전자서명법」 제3조에 따른 당사자 간 약정에 의한 서명으로 봅니다. 회사는 문서마다 동의한 버전, 문안의 해시, 동의 시각, 계정, 서명자 이름과 접속 정보(IP 주소·기기 정보)를 기록하고, 서명 전에 이메일 또는 휴대폰으로 본인 확인 절차를 거칠 수 있습니다.",
        "2. 회사는 관계 법령을 위반하지 않는 범위에서 이 약관과 부속을 변경할 수 있습니다. 변경하는 경우 적용일자, 변경 사유, 변경 내용을 적용일자 7일 전부터 파트너센터에 공지하고, 파트너에게 불리한 변경은 30일 전부터 공지하며 파트너센터 알림과 이메일로 각각 개별 통지합니다. 변경된 문서는 파트너센터에서 다시 서명하여 동의하며, 변경되지 않은 문서는 다시 서명하지 않습니다.",
        "3. 파트너는 변경 문서의 적용일 전까지 거부 의사를 표시하고 이 약관에 따른 관계를 종료할 수 있습니다. 회사가 제2항의 통지에서 「적용일까지 거부 의사를 표시하지 않으면 동의한 것으로 봅니다」라고 알렸음에도 파트너가 공지 후 30일 안에 거부 의사를 표시하지 않으면 변경 문서에 동의한 것으로 봅니다. 파트너센터의 재서명은 이 동의를 확인하는 절차입니다.",
        "4. 개별 계약이 이 약관·부속과 다른 경우 개별 계약이 우선합니다. 이 약관에 정하지 않은 사항은 관계 법령, 레이블리 이용약관, 회사가 파트너센터에 게시한 파트너 가이드에 따릅니다.",
      ].join("\n")],
      ["제2장 파트너의 지위와 파트너센터 이용", ""],
      ["제4조 (파트너의 지위)", [
        "1. 파트너는 독립한 사업자 또는 개인으로서 자신의 시간, 장소, 방법을 스스로 정하여 활동합니다. 이 약관과 파트너 활동은 회사와 파트너 사이에 근로관계, 고용관계, 대리관계, 동업관계를 만들지 않습니다.",
        "2. 회사는 파트너에게 고정급, 출퇴근, 전속 의무, 상시 근무 장소를 정하지 않습니다. 회사가 정하는 사전 승인, 보고, 교육 절차는 회사의 브랜드, 권리, 대외 커뮤니케이션, 개인정보와 영업 기회를 보호하기 위한 것이며 근로시간이나 장소를 구속하는 것이 아닙니다.",
        "3. 파트너는 회사를 대리하여 계약을 체결하거나, 가격·할인·보장·독점·권리 범위·일정을 확약하거나, 회사를 위하여 금품을 받을 수 없습니다.",
      ].join("\n")],
      ["제5조 (유형의 선언과 확인)", [
        "1. 파트너는 파트너센터에 처음 로그인할 때 자신의 유형(영상권리사 파트너, 크리에이터 파트너, 둘 다)을 선언하고, 그 유형에 해당하는 부속에 서명합니다.",
        "2. 회사는 협약 내용에 따라 선언을 확인하거나 파트너와 협의하여 정정합니다. 확인 전에도 파트너센터는 선언한 유형으로 열리며, 유형별 조건과 비율은 확인 뒤 표시됩니다.",
        "3. 유형을 바꾸려면 파트너센터에서 담당자에게 요청합니다. 유형이 추가되면 추가되는 부속에 서명하고 해당 교육을 이수한 뒤 그 활동을 시작합니다.",
      ].join("\n")],
      ["제6조 (파트너 자격, 계정과 파트너센터)", [
        "1. 파트너는 만 19세 이상의 개인 또는 사업자로서 관계 법령에 따라 활동이 제한되지 않은 자여야 합니다. 회사는 파트너 협약을 맺은 자에게 파트너 계정을 부여하고, 파트너는 파트너센터에서 약관 확인·서명, 교육, 실적 확인, 정산을 이용합니다.",
        "2. 파트너 계정은 본인만 사용합니다. 파트너는 비밀번호를 안전하게 관리하고, 계정이 도용되거나 유출된 것을 알게 되면 지체 없이 회사에 알립니다. 파트너가 계정 관리를 소홀히 하여 생긴 손해는 파트너가 부담합니다.",
        "3. 파트너센터는 베타 서비스로 운영될 수 있습니다. 회사는 화면, 문서, 기능을 예고 후 바꿀 수 있고, 운영상·기술상 필요한 경우 사전에 통지하고 서비스를 일시 중단할 수 있습니다. 긴급한 장애·보안 사유로 사전 통지가 어려운 경우에는 사후에 통지합니다.",
        "4. 회사는 사업상 필요에 따라 파트너 프로그램의 전부 또는 일부(특정 유형의 모집, 특정 기능이나 채널)를 종료하거나 중단할 수 있습니다. 이 경우 60일 전에 파트너에게 통지하며, 종료·중단일 전에 확정된 실적은 그대로 인정하고, 그 실적에서 발생하는 수익쉐어는 제11조에 따라 지급하며 제15조 제5항을 적용합니다.",
      ].join("\n")],
      ["제7조 (교육)", [
        "1. 파트너는 파트너 계정이 활성화되기 전, 그리고 교육 내용이 갱신될 때마다 회사가 통지한 기한(기본 14일) 안에 교육을 이수합니다. 교육은 공통 과정과 유형별 과정으로 구성됩니다.",
        "2. 기한 안에 교육을 이수하지 않으면 파트너 코드와 정산이 보류됩니다. 보류가 30일을 넘으면 회사는 제15조에 따라 관계를 종료할 수 있습니다. 보류 중에 이미 발생한 수익쉐어는 보전되며, 교육을 이수하면 보류가 풀립니다.",
        "3. 회사는 파트너가 활동에 필요한 소개 자료와 가이드를 파트너센터에서 제공하고 갱신합니다.",
        "4. 교육과 보고는 활동의 품질, 법규 준수, 브랜드 안내를 위한 것이며, 회사는 이를 출퇴근이나 근태를 관리하는 수단으로 운영하지 않습니다.",
      ].join("\n")],
      ["제3장 활동의 공통 규칙", ""],
      ["제8조 (금지행위)", [
        "파트너는 유형과 관계없이 다음을 하지 않습니다.",
        "1. 수익 보장, 투자 유인, 등급·승인·검수 면제, 멤버십 구독료 면제·할인, 특정 작품 제공을 약속하는 표현.",
        "2. 회사가 공개한 소개 페이지와 파트너 가이드에 실린 표현 밖의 수치(회원 수, 매출, 등급 기준, 승인 대기 인원 등)를 인용하는 것, 공지 전 정책·시점을 특정하는 것.",
        "3. 회사 직원이나 회사 공식 계정을 사칭하는 것, 마케팅 대행사명을 회사의 협력사로 표기하는 것.",
        "4. 회사 명의의 계정·상표·자료·연락처·후보 목록을 승인 없이 쓰거나 본인 또는 제3자의 이익을 위하여 전용·우회하는 것.",
        "5. 회사의 사전 서면 승인 없이 외부 인력을 써서 활동하는 것. 외부 인력을 쓰려면 파트너가 법인을 두고 그 인력을 직원으로 고용하여 회사에 소개한 뒤에만 가능합니다.",
        "6. 이 약관에 따른 관계가 존속하는 동안, 회사의 사전 서면 승인 없이 레이블리와 같은 방식(영상권리사의 작품을 크리에이터가 숏폼으로 제작·유통하고 수익을 나누는 협업 플랫폼)을 운영하는 사업자를 위하여 이 약관과 같거나 비슷한 소개·유치 활동을 하는 것.",
        "7. 회원·영상권리사의 연락처 등 개인정보를 본인 동의 없이 수집·보관하거나 회사 밖으로 전달하는 것.",
        "8. 홍보·소개 활동에서 자신이 회사의 파트너로서 경제적 대가를 받는다는 사실을 숨기는 것. 파트너는 관계 법령(표시·광고의 공정화에 관한 법률 등)에 따라 「레이블리 파트너」임을 밝힙니다.",
        "9. 자동 실행이나 강제 이동(사용자의 의사와 무관하게 링크가 열리게 하는 것), 위장 링크나 파트너 코드를 숨기는 단축 URL, 자동화 도구·봇으로 만든 가입이나 접속, 그 밖의 기술적 수단으로 실적을 만들거나 부풀리는 것. 이렇게 만든 실적은 인정하지 않습니다.",
      ].join("\n")],
      ["제8조의2 (파트너의 책임)", [
        "1. 파트너는 활동에 관한 세금, 사회보험, 사업자 등록 등 자신의 법령상 의무를 스스로 이행합니다.",
        "2. 파트너는 활동에서 표시·광고, 전자상거래, 개인정보, 저작권, 반부패 등 관계 법령을 지키며, 위반으로 회사·회원·제3자에게 손해가 생기면 파트너가 책임집니다.",
      ].join("\n")],
      ["제9조 (회사의 의무와 판단)", [
        "1. 회사는 파트너가 발굴·소개한 거래에 대하여 수익쉐어를 피할 목적으로 관계회사·임직원·제3자를 통하여 우회하여 거래하지 않습니다. 이 항은 제4항의 사업 판단을 제한하지 않으며, 회피 목적은 파트너가 구체적 근거로 밝힙니다.",
        "2. 회사는 파트너 활동에 필요한 소개 자료, 파트너 가이드, 화면 설명 자료를 제공하고 갱신합니다.",
        "3. 회사는 부속이 정한 회신 기한을 지키고, 실적 인정 여부와 사유를 파트너센터에서 확인할 수 있게 합니다.",
        "4. 회사는 거래상대방의 선정, 계약 체결 여부, 가격, 조건, 권리 범위, 진행과 매출 인식을 독자적인 사업 판단으로 결정합니다. 회사가 거래를 체결하지 않거나 매출이 발생하지 않더라도 별도의 보상 의무를 지지 않습니다. 이 항은 제1항에 우선합니다.",
        "5. 실적의 인정 여부와 인정 단계는 이 약관·부속·개별 계약이 정한 객관적 기준에 따라 회사가 최종 판단하며, 파트너는 파트너센터에서 판단 결과와 사유를 확인하고 제11조 제3항의 절차로 이의를 제기할 수 있습니다.",
      ].join("\n")],
      ["제4장 수익쉐어와 정산", ""],
      ["제10조 (수익쉐어의 원칙)", [
        "1. 수익쉐어의 비율과 기준 금액은 개별 계약으로 정합니다. 개별 계약에 정함이 없으면 회사가 파트너에게 비율을 통지하고 파트너가 파트너센터에서 동의한 비율을 적용하며, 회사는 그 비율을 파트너센터 본인 화면에 표시합니다. 비율을 바꾸려면 회사는 30일 전에 파트너에게 통지하고 동의를 받으며, 파트너가 동의하지 않으면 종전 비율이 유지되고 어느 쪽이든 제15조 제1항에 따라 관계를 종료할 수 있습니다. 파트너는 자신의 비율만 볼 수 있으며, 다른 파트너의 비율·존재·실적은 제공되지 않습니다.",
        "2. 한 수익에 파트너가 한 명이면 그 파트너의 비율을 그대로 적용하고, 영상권리사 파트너가 가져온 작품으로 크리에이터 파트너가 유치한 크리에이터가 수익을 낸 경우처럼 두 유형의 파트너가 함께 만든 수익이면 각 파트너에게 자기 비율의 절반씩을 적용합니다. 크리에이터와 영상권리사의 몫은 각자의 계약으로 정해지며 파트너 몫으로 줄지 않습니다.",
        "3. 수익쉐어는 회사가 실제로 수령한 금액을 기준으로 발생합니다. 환불, 취소, 해지, 차지백, 할인, 제3자에게 실제 지급한 비용이 있으면 그에 상응하여 발생하지 않거나 다음 정산에서 조정됩니다.",
        "4. 부속이 실적에서 제외한 대상이나 거래는 수익쉐어 대상에서 제외합니다. 다만 별도 서면 합의가 있으면 예외로 합니다.",
      ].join("\n")],
      ["제11조 (정산과 지급)", [
        "1. 회사는 매출이 실제 수령된 달을 기준으로 정산하고, 개별 계약에 다른 정함이 없으면 그 익익월 25일까지 정산 내역과 함께 파트너가 등록한 계좌로 지급합니다. 지급일이 금융기관 휴무일이면 다음 영업일에 지급합니다.",
        "2. 파트너는 파트너센터에 정산 정보(개인·사업자 구분, 계좌, 사업자등록증 등)를 등록하고 정산을 신청합니다. 정산 정보를 등록하기 전에는 신청이 잠깁니다. 수익쉐어는 부가가치세를 제외한 금액입니다. 사업자 파트너는 회사에 세금계산서를 발행하고 회사는 부가가치세를 더하여 지급하며, 개인 파트너에게는 사업소득으로 보아 관계 법령에 따른 원천징수(소득세·지방소득세)를 한 뒤 지급하고 지급명세서를 제출합니다.",
        "3. 파트너는 정산 내역을 받은 날부터 30일 안에 근거를 붙여 이의를 제기할 수 있고, 회사는 이의를 받은 날부터 30일 안에 파트너 몫 산정 근거(회사 수령액과 공제 항목의 요약, 인정 실적 목록)를 제공합니다. 영상권리사·크리에이터 등 제3자와의 계약서 원문, 제3자의 개인정보·거래 조건은 제공 대상이 아닙니다. 회사는 정산 자료를 5년간 보관합니다.",
        "4. 교육 미이수, 정산 정보 미등록, 제15조에 따른 종료 검토 중에는 정산이 보류될 수 있습니다. 보류 중에 이미 발생한 수익쉐어는 보전됩니다.",
        "5. 회사가 정당한 사유 없이 수익쉐어 지급이나 정산 자료 제공을 지연·거절하거나 제9조 제1항을 위반한 경우, 파트너는 7일 이상의 시정 기간을 두고 시정되지 않으면 관계를 종료할 수 있으며, 종료 전에 발생한 수익쉐어는 계속 지급받습니다.",
        "6. 허위 가입, 본인·가족·관리 계정 가입, 중복 계정, 절차 우회 등 부속이 실적에서 제외한 사유가 지급 뒤에 드러난 경우, 회사는 그 실적으로 지급된 수익쉐어를 다음 정산에서 상계하거나 파트너에게 반환을 청구할 수 있습니다. 회사는 근거를 파트너센터 또는 이메일로 알립니다.",
        "7. 어느 정산월의 수익쉐어(부가가치세·원천징수 전 금액)가 1만원 미만이면 그 달에는 지급하지 않고 다음 정산월로 이월하며, 이월된 금액을 합한 수익쉐어가 1만원 이상이 되는 정산월에 함께 지급합니다. 이월 중인 금액은 파트너센터 정산 화면에 표시되고, 관계가 종료되면 금액과 관계없이 마지막 정산에서 지급합니다.",
      ].join("\n")],
      ["제5장 비밀유지와 개인정보", ""],
      ["제12조 (비밀유지)", [
        "1. \"비밀정보\"란 회사의 사업 계획, 매출·정산 자료, 가격·조건, 수익쉐어 조건(파트너 본인의 것을 포함), 영상권리사·크리에이터의 계약·협상 정보, 영업 파이프라인, 계정·접근 권한, 문서·화면, 개인정보와 이들로부터 도출한 자료를 말하며, 문서·파일·메신저·구두·화면·이미지 등 형태를 가리지 않습니다. 다른 파트너가 누구인지, 누구를 유치했는지도 비밀정보입니다.",
        "2. 파트너의 위반 없이 공지된 정보, 파트너가 비밀유지 의무 없이 적법하게 제3자로부터 얻은 정보, 비밀정보를 쓰지 않고 독자적으로 만든 정보, 법령이나 법원 명령으로 공개가 필요한 정보는 비밀정보에서 제외합니다. 법령상 공개는 회사에 미리 알리고 최소한의 범위로 합니다.",
        "3. 파트너는 비밀정보와 개인정보를 이 약관의 목적 범위에서만 씁니다. 파트너는 통상적인 업무용 AI 서비스를 업무에 쓸 수 있으나, 비밀정보와 개인정보는 AI 서비스에 입력하지 않습니다.",
        "4. 파트너는 계정·문서·저장매체를 안전하게 관리하고, 유출·오발송·분실·무단 접근을 알게 되면 지체 없이, 늦어도 24시간 안에 회사에 알립니다.",
        "5. 파트너는 관계 종료 후 3영업일 안에 회사의 비밀정보를 모두 삭제하거나 반환하고, 회사가 요청하면 삭제·반환 확인서를 제출합니다.",
        "6. 비밀유지 의무는 관계 종료 후 3년간 유지됩니다. 다만 영업비밀과 개인정보에 관한 의무는 그 정보가 적법하게 공개되거나 관계 법령상 보유·파기 의무가 끝날 때까지 유지됩니다.",
        "7. 파트너가 다른 파트너나 회원으로부터 수익쉐어 조건 등 비밀정보를 요구받은 경우 답하지 않고 회사에 그 사실을 알립니다.",
      ].join("\n")],
      ["제13조 (개인정보)", [
        "1. 파트너는 유치 대상의 연락처를 본인 동의를 받아 회사 담당자에게 전달하며, 별도로 수집·보관하지 않습니다.",
        "2. 회사는 파트너의 계정 정보, 정산 정보, 서명 기록, 파트너센터 이용 기록을 개인정보처리방침에 따라 처리합니다. 파트너센터에 표시되는 실적은 집계치이며 회원 개인을 식별하는 정보를 포함하지 않습니다.",
      ].join("\n")],
      ["제6장 종료와 책임", ""],
      ["제14조 (약관 위반의 시정과 소명)", [
        "1. 회사는 파트너가 이 약관 또는 부속을 위반한 경우 파트너센터 알림 또는 이메일로 위반 내용과 시정 기한을 알립니다. 위반이 계속되거나 반복되면 파트너 코드와 정산을 보류할 수 있습니다.",
        "2. 파트너는 시정 기한 안에 통지에 안내된 방법(파트너센터 문의 또는 담당자 이메일)으로 근거를 붙여 소명할 수 있습니다. 회사는 소명을 받은 날부터 7영업일 안에 검토 결과를 알리며, 소명이 받아들여지면 보류를 풀고 그동안 보류된 수익쉐어를 다음 정산에서 지급합니다.",
        "3. 회사가 파트너에게 하는 위반·보류·정지·활동 판정·해지 통지에는 해당 파트너의 파트너 코드를 표기합니다. 파트너 코드가 없는 통지는 파트너에게 한 통지로 보지 않습니다.",
      ].join("\n")],
      ["제15조 (종료와 해지)", [
        "1. 회사 또는 파트너는 상대방에게 종료 희망일 1개월 전까지 파트너센터, 이메일 또는 회사가 지정한 협업 채널의 전자기록으로 알리고 장래를 향하여 이 약관에 따른 관계를 종료할 수 있습니다.",
        "2. 회사는 파트너가 다음에 해당하면 7일 이상의 시정 기간을 두고 시정되지 않을 때 관계를 해지할 수 있습니다. 제7조 교육 미이수(보류 30일 초과), 부속이 정한 절차 위반, 제8조 금지행위, 제12조 비밀유지 위반, 허위 실적 보고, 그 밖의 이 약관·부속 위반.",
        "3. 회사는 파트너가 비밀정보·개인정보·회사 자료를 경쟁사에 반출하거나, 회사를 사칭하여 대외 확약을 하거나, 허위 실적을 제출하거나, 법령·저작권·개인정보·반부패 규정을 중대하게 위반한 경우 시정 기간 없이 즉시 해지할 수 있습니다.",
        "4. 관계가 종료되더라도 종료 전에 발생한 수익쉐어, 제12조 비밀유지, 제13조 개인정보, 자료 반환·삭제 의무와 법령상 의무는 계속 적용됩니다.",
        "5. 종료 전에 파트너가 인정 실적으로 확정한 회원·영상권리사와의 거래에서 종료 후에 발생하는 갱신·연장·후속 거래에 대해서는 개별 계약에 따라 수익쉐어를 지급하며, 개별 계약에 정함이 없으면 종료일부터 12개월까지 지급합니다. 다만 제2항·제3항에 따라 파트너의 위반으로 해지된 경우에는 이 항을 적용하지 않고, 해지일까지 발생한 수익쉐어만 지급합니다. 크리에이터 파트너의 지급 기간은 부속 B 가 따로 정합니다.",
      ].join("\n")],
      ["제16조 (손해배상과 책임의 한도)", [
        "1. 회사 또는 파트너가 이 약관·부속을 위반하여 상대방에게 손해를 입힌 경우 법령이 정하는 범위에서 책임을 집니다.",
        "2. 파트너에 대한 회사의 책임은 법령이 허용하는 범위에서 손해 발생 전 최근 12개월 동안 파트너가 지급받은 수익쉐어 총액을 한도로 합니다(회사의 고의 또는 중대한 과실은 제외).",
        "3. 파트너는 회사를 대리하지 않으며, 회사는 이를 회원 이용약관과 가입 화면, 파트너 소개 자료에 밝힙니다. 회사는 파트너가 회원이나 제3자에게 한 약속·확약에 대하여 책임지지 않으며, 그로 인한 분쟁은 파트너가 자신의 책임과 비용으로 해결합니다.",
      ].join("\n")],
      ["제7장 일반 사항", ""],
      ["제17조 (통지)", "회사가 파트너에게 하는 통지는 파트너센터 알림, 파트너가 등록한 이메일 또는 회사가 지정한 협업 채널의 전자기록으로 할 수 있으며, 파트너 전체에 대한 통지는 파트너센터 공지로 갈음할 수 있습니다. 회사의 사전 승인, 확인, 회신도 같은 방법으로 합니다."],
      ["제18조 (준거법과 관할)", "이 약관은 대한민국 법령에 따르며, 이 약관에 정하지 않은 사항은 관계 법령과 상관례에 따릅니다. 이 약관과 파트너 활동에 관한 분쟁은 「민사소송법」이 정하는 관할 법원에 제기하며, 회사와 파트너는 회사 본점 소재지를 관할하는 법원을 합의관할 법원으로 추가합니다. 파트너가 사업자인 경우 회사 본점 소재지 법원을 제1심 관할 법원으로 합니다. 강행법규에 따른 관할이 있는 경우 그에 따릅니다."],
      ["부칙", [
        "1. 이 약관은 회사가 파트너센터에서 이 약관의 서명을 받기 시작한 날부터 시행하며, 각 파트너에게는 그 파트너가 서명한 때부터 적용됩니다.",
        "2. 이 약관 시행 전에 「파트너 업무 제휴 계약(표준) v1.0」에 서명한 파트너는 유형을 선언하고 이 약관과 해당 부속에 다시 서명하며, 다시 서명하기 전까지는 종전 계약이 적용됩니다.",
      ].join("\n")],
    ],
    checks: [
      { key: "body", label: "이용약관 본문(제1조~제18조·부칙)을 읽고 동의합니다." },
      { key: "status", label: "파트너는 독립한 사업자·개인이며 회사를 대리하지 않는다(제4조·제16조)는 점을 이해했습니다." },
      { key: "banned", label: "금지행위(제8조)와 비밀유지(제12조)를 지키겠습니다." },
      { key: "share", label: "수익쉐어 원칙 — 두 유형의 파트너가 함께 만든 수익은 각자 자기 비율의 절반(제10조) — 을 이해했습니다." },
    ],
  },
  {
    key: TERMS_RIGHTS_KEY,
    version: "v1.0",
    title: "파트너센터 이용약관 부속 A — 영상권리사 파트너",
    short: "부속 A (영상권리사)",
    appliesTo: ["video", "both"],
    intro: "공통 약관과 함께 서명합니다. 이 부속은 영상권리사 파트너와 두 유형을 모두 선언한 파트너에게 적용됩니다. 용어는 공통 약관을 따릅니다.",
    sections: [
      ["A-1조 (활동의 범위)", "영상권리사 파트너는 방송사·제작사·OTT·유튜브 채널 운영사 등 영상권리사를 발굴하고, 회사와 영상권리사 사이의 미팅을 주선하며, 회사가 작품 제공 계약을 맺도록 돕습니다. 계약의 체결·조건·가격·권리 범위는 회사가 정합니다."],
      ["A-2조 (영업의 사전 절차)", [
        "1. 파트너는 영상권리사에 처음 연락하거나 제안서를 보내기 전에 다음 절차를 모두 완료합니다. ㈎ 파트너센터 「권리사 영업」에 후보를 등록 ㈏ 회사의 승인 ㈐ 회사가 제공한 이메일·자료·채널로 연락.",
        "2. 후보 등록에는 회사명, 운영 채널 또는 대표 작품, 유형, 담당 부서·직급, 접근 계획을 적습니다. 담당자의 이름·연락처·이메일 등 개인정보는 적지 않습니다.",
        "3. 이 절차를 거치지 않은 연락·미팅·제안·후보 발굴은 실적과 수익쉐어에 반영하지 않습니다. 다만 제3항의 승인 간주에 해당하거나, 회사가 파트너의 영업 접촉 대상과 후속 제안·협상·계약·거래를 진행하거나 매출을 수령한 경우에는 절차를 완료한 것으로 봅니다.",
      ].join("\n")],
      ["A-3조 (회사의 회신)", [
        "1. 회사는 후보 등록을 받은 날부터 5영업일 안에 승인 또는 구체적인 사유를 붙인 거절을 파트너센터에 회신합니다. 기한 안에 회신하지 않으면 승인한 것으로 봅니다.",
        "2. 회사는 후보의 적합성, 기존 진행 건과의 중복, 접근 전략, 법무·컴플라이언스상 유의사항을 검토하여 결과를 파트너센터에서 공유합니다. 거절 사유는 파트너에게 표시됩니다.",
        "3. 긴급한 영업 기회가 있으면 파트너는 등록 시 이를 표시하여 2영업일 안의 회신을 요청할 수 있습니다. 회사의 회신 지연으로 영업 기회를 잃거나 활동이 진행되지 못한 기간은 파트너의 실적 산정에서 불리하게 반영하지 않습니다.",
      ].join("\n")],
      ["A-4조 (실적의 인정)", [
        "1. 실적은 파트너의 주선으로 회사 대표 또는 회사의 의사결정권자가 영상권리사의 권리 협상 또는 사업 협력 의사결정권자나 정당한 위임을 받은 담당자와 대면 미팅, 온라인 미팅, 이메일 또는 통화로 쌍방 협의를 실제로 진행한 경우에 인정합니다.",
        "2. 파트너는 각 미팅에 관하여 대상, 일시, 참석자, 성사 여부를 확인할 수 있는 증빙(이메일, 통화 기록, 메시지, 파트너센터 기록 등)을 회사에 제출합니다.",
        "3. 다음은 실적으로 인정하지 않습니다. ㈎ 단순 후보 조사, 승인 없는 연락, 일괄 발송, 회신 없는 재촉 ㈏ 같은 담당 부서 권리자와의 반복 미팅(원칙적으로 1건만 인정) ㈐ 회사가 파트너의 승인 요청 전에 이미 접촉·협상·관리 중이었고 파트너에게 그 사실을 공유한 대상 ㈑ 회사의 독자적 영업이나 인바운드 문의에 주로 기초한 대상(회사 요청으로 파트너가 대응·연결한 경우는 제외) ㈒ 허위·중복 보고에 기초한 미팅.",
        "4. 기존 계약 중인 영상권리사라도 같은 회사 안의 다른 부서를 대상으로 미팅을 진행한 경우는 실적에 포함합니다. 회사가 기존 진행 건을 이유로 제외하려면 승인 회신 때 그 사실을 표시하여야 하며, 표시하지 않은 대상은 제외할 수 없습니다.",
        "5. 회사가 승인하지 않은 후보라도 이후 회사가 파트너의 주선으로 진행된 그 상대방과 후속 협상, 제안, 계약 또는 거래를 진행하거나 매출을 수령한 경우에는 해당 건을 승인한 것으로 봅니다.",
      ].join("\n")],
      ["A-5조 (영상권리사를 상대로 한 표현의 제한)", [
        "파트너는 영상권리사에게 다음을 하지 않습니다.",
        "1. 회사가 작품의 판권을 사거나 저작권을 양도받는다고 설명하는 것. 회사는 영상권리사가 비용 없이 작품을 제공하고 발생 수익을 나누는 협업을 제안합니다.",
        "2. 배분율, 플랫폼 범위, 지오블락, 독점 공급, 특정 채널 배정, 일정을 파트너가 정하거나 확약하는 것.",
        "3. 다른 영상권리사의 계약 조건·작품 목록·수익을 언급하는 것.",
        "4. 회사 명의로 제안서·계약서를 만들거나 회사의 승인 없이 수정하는 것.",
      ].join("\n")],
      ["A-6조 (계약 연결과 수익쉐어)", [
        "1. 회사가 파트너의 실적으로 인정한 영상권리사와 작품 제공 계약을 체결하면, 회사는 파트너센터에서 그 회사를 파트너의 실적으로 연결합니다. 연결된 회사의 작품에서 발생한 매출은 공통 약관 제10·11조와 개별 계약에 따라 수익쉐어 대상이 됩니다.",
        "2. 수익쉐어의 비율, 기준 금액, 공제 항목은 개별 계약 또는 파트너센터 본인 화면에 따릅니다.",
      ].join("\n")],
      ["A-7조 (종료 후의 보호)", "관계 종료 전에 실적으로 확정된 영상권리사와 체결된 계약 및 그 갱신·연장·추가 계약·후속 거래에 대해서는 공통 약관 제15조 제5항에 따라 수익쉐어를 지급합니다."],
    ],
    checks: [
      { key: "body", label: "부속 A 본문(A-1조~A-7조)을 읽고 동의합니다." },
      { key: "process", label: "후보 등록 → 회사 승인 → 회사가 제공한 채널로 연락 순서를 지키지 않은 접촉은 실적이 아님(A-2조)을 이해했습니다." },
      { key: "words", label: "판권·독점·배분율·플랫폼 범위·일정을 파트너가 확약하지 않겠습니다(A-5조)." },
    ],
  },
  {
    key: TERMS_CREATOR_KEY,
    version: "v1.6", // 2026-09-28 대표 결정 ①·③: B-2조 2항 — 링크로 들어온 회원은 코드를 바꿀 수 없고, 직접 적는 코드는 있는 코드만 받으며, 잘못 적힌 코드는 회원 본인 요청으로 30일 안에 바로잡는다. 불리하지 않은 명확화라 재서명 없음(결정 ②) — v1.5 서명자는 요구 버전 v1.5 그대로, 미서명·새 파트너만 v1.6(마이그레이션 20261002100000). 7일 공지는 대표가 어드민 「통지」로. v1.5(2026-09-15): B-7 「별도 확인」 상자 보류(2027-01-01 시행 예정, ops_schedule) — 조문 본문은 그대로, 별도 상자만 뺌. v1.4(2026-09-11) 벤치마크 반영: B-3 7호(기술적 수단 가입 제외) · B-4 5항 표준 문구·위치 · B-4 6항 기술적 부정행위 · B-4 7항 홍보 채널 사전 통보
    title: "파트너센터 이용약관 부속 B — 크리에이터 파트너",
    short: "부속 B (크리에이터)",
    appliesTo: ["marketing", "both"],
    intro: "공통 약관과 함께 서명합니다. 이 부속은 크리에이터 파트너와 두 유형을 모두 선언한 파트너에게 적용됩니다. 용어는 공통 약관을 따릅니다.",
    sections: [
      ["B-1조 (활동의 범위)", "크리에이터 파트너는 쇼츠 크리에이터에게 레이블리를 소개하고 가입을 안내하며, 가입한 크리에이터가 채널 등록·승인까지 이르도록 돕습니다. 가입 승인, 채널 승인, 작품 사용 승인, 검수는 회사가 정합니다."],
      ["B-2조 (파트너 코드와 실적의 기준)", [
        "1. 회사는 파트너에게 파트너 코드와 링크를 부여합니다. 파트너는 파트너센터 「내 링크 만들기」로 링크를 만들고, 링크 없이 가입하는 사람에게는 코드를 직접 알려 줍니다.",
        "2. 실적은 회원이 가입할 때 가입 화면에 기록된 파트너 코드를 기준으로 인정합니다. 파트너 링크로 들어온 회원은 그 링크의 코드가 기록되며 회원이 바꿀 수 없습니다. 링크 없이 가입하는 회원은 「추천 코드」 칸에 코드를 직접 적으며, 회사는 실제로 있는 코드만 받습니다. 잘못 적힌 코드는 회원 본인의 요청으로 회사가 가입 뒤 30일 안에 바로잡을 수 있습니다. 링크의 유입 정보는 링크를 누른 뒤 24시간 안에 가입할 때만 남고 통계에만 씁니다.",
        "3. 실적으로 인정되는 단계(가입 신청, 운영팀 승인, 첫 채널 승인 등)와 수익쉐어가 발생하는 단계는 개별 계약 또는 파트너센터 본인 화면에 따릅니다.",
      ].join("\n")],
      ["B-3조 (실적에서 제외하는 경우)", [
        "다음은 실적으로 인정하지 않습니다.",
        "1. 파트너 본인, 가족, 파트너가 운영·관리하는 계정.",
        "2. 이미 가입된 회원, 승인이 거절되거나 탈퇴한 계정, 허위 정보로 가입한 계정.",
        "3. 파트너 코드를 재배포하거나 회사가 정한 절차를 우회하여 만든 가입.",
        "4. B-4조·B-5조를 위반한 활동으로 만든 가입.",
        "5. 실적으로 인정된 회원이 다시 소개하여 가입한 회원. 파트너의 실적은 파트너 본인이 직접 소개한 회원에 한합니다.",
        "6. 파트너는 다른 사람을 파트너로 모집하거나 추천하여 대가를 받지 않으며, 회사는 파트너 모집·추천에 대한 대가를 지급하지 않습니다.",
        "7. 자동 실행·강제 이동, 위장 링크, 파트너 코드를 숨기는 단축 URL, 자동화 도구·봇 등 기술적 수단으로 만든 가입(B-4조 제6항, 공통 약관 제8조 제9호).",
      ].join("\n")],
      ["B-4조 (홍보 채널의 제한)", [
        "1. 파트너는 본인 SNS, 커뮤니티, 오프라인 세미나 등 회사가 허용한 방법으로 홍보합니다.",
        "2. 회사가 파트너 가이드에서 지정한 홍보 금지 사이트·채널(불법 복제·도박·성인·혐오 관련 사이트, 회사가 별도로 정한 채널 등)에서는 홍보하지 않습니다.",
        "3. 회원 전용 가이드, 데모 사이트 접근 코드, 회사가 파트너에게만 제공한 자료를 재배포하지 않습니다.",
        "4. 가입이나 코드 입력의 대가로 크리에이터에게 금전·물품·수익쉐어의 일부를 제공하거나 약속하지 않습니다. 이렇게 만든 가입은 실적에서 제외하고, 이미 지급된 수익쉐어는 공통 약관 제11조 제6항에 따라 환수합니다.",
        "5. 홍보·소개할 때 자신이 회사의 파트너로서 경제적 대가를 받는다는 사실을 밝힙니다(공통 약관 제8조 제8호). 표준 문구는 「이 게시물은 레이블리 파트너 활동의 일환으로, 소개에 따른 대가를 받습니다.」이며, 게시물의 첫 부분(제목 또는 본문 첫 줄), 영상 설명란 첫 줄, DM·이메일의 첫 인사 뒤에 넣습니다. 회사는 파트너센터 「내 링크 만들기」에서 이 문구를 제공합니다.",
        "6. 자동 실행이나 강제 이동, 위장 링크, 파트너 코드를 숨기는 단축 URL, 자동화 도구·봇으로 가입이나 접속을 만드는 것, 그 밖의 기술적 수단으로 실적을 만들거나 부풀리는 것을 하지 않습니다. 이렇게 만든 가입은 실적에서 제외합니다(B-3조 제7호).",
        "7. 파트너는 홍보에 쓰는 채널(SNS 계정, 블로그, 커뮤니티, 오프라인 행사 등)을 회사가 정한 방법(파트너센터 등록 또는 담당자 통보)으로 미리 알리고, 회사는 그 채널의 대가성 표시 여부를 확인할 수 있습니다. 알리지 않은 채널에서 만든 가입은 회사가 실적에서 제외할 수 있습니다.",
      ].join("\n")],
      ["B-5조 (크리에이터를 상대로 한 표현의 제한)", [
        "파트너는 크리에이터에게 다음을 하지 않습니다.",
        "1. 멤버십 구독료 면제·할인, 시행일 연기, 승인·검수 면제를 파트너가 약속하는 것. 등급 승급권은 회사가 판매하는 상품이므로 회사가 게시한 금액·기간·좌석·환불 조건을 그대로 안내하는 것은 가능하나, 승급권 구매로 얻을 수익을 말하거나 보장하지 않습니다.",
        "2. 특정 작품의 제공, 배분율, 특정 채널 배정을 확약하는 것.",
        "3. 회사가 공개한 소개 페이지와 이용 가이드에 실린 멤버십 구독료·혜택·등급 안내 밖의 수치나 시점을 말하는 것.",
        "4. 회사 직원이나 공식 계정을 사칭하는 것.",
        "파트너가 약속할 수 있는 범위는 회사가 게시한 이용 가이드와 파트너 가이드에 적힌 내용까지입니다. 그 밖의 요청은 회사 담당자에게 연결합니다.",
      ].join("\n")],
      ["B-6조 (크리에이터의 개인정보)", "파트너는 크리에이터의 연락처, 채널 수익, 등급 등 개인정보를 별도로 수집·보관하지 않으며, 담당자 연결이 필요한 경우 본인 동의를 받아 회사에 전달합니다. 파트너센터의 유치 현황은 집계치만 표시하며, 파트너는 유치한 회원의 명단을 회사에 요구하거나 외부에 공개하지 않습니다."],
      ["B-7조 (수익쉐어와 지급 기간)", [
        "1. 크리에이터 파트너의 수익쉐어는 실적으로 인정된 회원이 레이블리에서 낸 수익에서 발생한 회사의 매출을 기준으로 하며, 비율과 발생 단계는 개별 계약 또는 파트너센터 본인 화면에 따릅니다. 영상권리사 파트너가 가져온 작품으로 낸 수익에는 공통 약관 제10조 제2항의 절반 규칙을 적용합니다.",
        "2. 수익쉐어는 파트너가 활동 중인 동안 계속 지급합니다. \"활동 중\"이란 직전 3개월(정산월 말일 기준으로 그 달을 포함한 3개월) 동안 다음 중 하나를 충족한 상태를 말합니다. ㈎ 파트너의 실적으로 인정된 회원이 낸 수익에서 발생한 회사 매출(부가가치세를 제외하고 회사가 실제 수령한 금액)의 합계가 1,000만원 이상 ㈏ 파트너의 실적으로 인정된 회원 가운데 그 기간에 실버 등급 이상으로 확정된 크리에이터가 100명 이상.",
        "3. 파트너 계정이 활성화된 날부터 6개월은 제2항의 판정을 하지 않습니다(신규 파트너 유예).",
        "4. 유예가 끝난 뒤 어느 정산월 말일 기준으로 제2항의 기준을 충족하지 못하면 그날을 활동 중단일로 보고, 회사는 파트너센터 알림 또는 이메일로 알립니다. 활동 중단일부터 6개월 동안은 그때까지 인정된 회원의 수익에 대한 수익쉐어를 계속 지급하고, 6개월이 지나면 지급을 중단합니다.",
        "5. 활동 중단일부터의 누적이 회사 매출 2,000만원 또는 실버 등급 이상으로 확정된 크리에이터 200명에 이르면 그 시점에 활동 중으로 돌아가며, 지급은 중단 없이 이어집니다. 6개월이 지나 지급이 중단된 뒤에 제2항의 기준을 다시 충족하면, 그 뒤에 새로 인정된 회원의 수익부터 다시 지급합니다.",
        "6. 파트너가 공통 약관 제15조 제1항에 따라 스스로 관계를 종료하는 경우 종료일을 활동 중단일로 보아 제4항을 적용합니다. 공통 약관 제15조 제5항의 12개월 규정은 크리에이터 파트너의 크리에이터 유치 수익쉐어에는 적용하지 않고 이 조를 적용합니다.",
        "7. 이 조의 활동 기준과 지급 기간은 크리에이터 유치에서 발생한 수익쉐어에만 적용합니다. 두 유형을 모두 선언한 파트너의 영상권리사 영업 수익쉐어는 부속 A 에 따르며 이 조의 영향을 받지 않습니다.",
        "8. 파트너센터 본인 화면에 직전 3개월의 회사 매출 합계, 실버 등급 이상 확정 크리에이터 수, 활동 상태(유예·활동 중·중단·지급 종료)와 중단 시 누적 달성 현황을 표시합니다.",
        "9. 회사는 이 조의 활동 기준과 지급 중단 조건을 서명 화면에서 따로 표시하고 파트너의 확인을 받습니다.",
      ].join("\n")],
    ],
    checks: [
      { key: "body", label: "부속 B 본문(B-1조~B-7조)을 읽고 동의합니다." },
      { key: "code", label: "실적은 가입 화면 「추천 코드」 칸에 적힌 코드 기준(B-2조)임을 이해했습니다." },
      { key: "no_mlm", label: "다른 사람을 파트너로 모집·추천해 대가를 받지 않겠습니다(B-3조 6항)." },
    ],
    // B-7 「별도 확인 — 활동 기준·지급 중단」 상자는 2026-09-15 대표 지시로 보류 — 2027-01-01 시행 예정(ops_schedule 등록).
    // 되살릴 때: separateChecks: [{ key: "b7_activity", label: "활동 기준 — 직전 3개월 회사 매출 1,000만원 또는 실버 등급 이상 확정 100명(신규 파트너 6개월 유예) — 과, 활동 중단 뒤 6개월이 지나면 크리에이터 유치 수익쉐어 지급이 중단되는 조건(B-7조)을 별도로 확인했습니다." }]
    // + 서버 partner_agreement_sign 의 b7_activity 검사 복구 + 버전 상향(번들 먼저 배포 → 요구 버전).
  },
  {
    key: TERMS_MARK_KEY,
    version: "v1.0", // 2026-09-22 신설 — 파트너 마크(「레이블리 등록 파트너」) 사용 규정. 자료실(/partner/library) 내려받기는 이 문서 서명 뒤에만 열린다. 원고 docs/ops/policy/partner-terms/mark.md · 기획 docs/ops/partner-library-plan.md
    title: "파트너센터 이용약관 부속 C — 파트너 마크 사용 규정",
    short: "부속 C · 마크",
    appliesTo: ["video", "marketing", "both"],
    intro: "이 문서는 모든 유형의 파트너가 서명합니다. 회사가 파트너에게 제공하는 「레이블리 등록 파트너」 마크(그림·문구·파트너 코드)를 어디에 어떻게 쓸 수 있는지, 자격을 잃으면 어떻게 거두는지를 정합니다. 이 문서에 정하지 않은 사항은 공통 약관을 따릅니다.",
    sections: [
      ["C-1조 (마크의 정의)", [
        "1. \"마크\"란 회사가 파트너센터 자료실에서 파트너에게 제공하는 「레이블리 등록 파트너」 표식으로, 레이블리 로고, 「Laeebly Partner」 문구, 발급 연도, 파트너 코드로 이루어진 그림 파일과 붙여넣기 코드를 말합니다.",
        "2. 마크는 파트너가 회사에 등록된 파트너이고 서명 시점에 자격이 유지되고 있다는 사실만 표시합니다. 마크는 파트너가 회사를 대리하거나 회사 명의로 계약을 체결하거나 조건을 확약할 권한이 있다는 뜻이 아닙니다(공통 약관 제4조).",
      ].join("\n")],
      ["C-2조 (사용 허락)", [
        "1. 회사는 파트너에게 이 문서가 정한 범위에서 마크를 사용할 비독점적이고 양도할 수 없으며 재허락할 수 없는 권리를 허락합니다. 이 허락은 상표법 제97조의 통상사용권 설정에 해당하며, 파트너 자격이 유지되는 동안만 유효합니다.",
        "2. 파트너는 마크 파일을 다른 사람이나 다른 사업자에게 전달하거나 대신 사용하게 할 수 없습니다. 자회사·소속 직원·외주 업체도 마찬가지입니다.",
        "3. 마크는 파트너센터 자료실에서 본인 계정으로 내려받은, 본인의 파트너 코드가 표시된 파일만 사용합니다. 코드가 없거나 다른 사람의 코드가 표시된 마크는 회사의 마크가 아닙니다.",
      ].join("\n")],
      ["C-3조 (표시할 수 있는 말과 없는 말)", [
        "1. 파트너는 마크와 함께 「레이블리 등록 파트너」 또는 「Laeebly Registered Partner」라고 표시할 수 있습니다.",
        "2. 파트너는 마크와 함께, 또는 마크 없이도, 「레이블리 공식」, 「공식 파트너」, 「인증 파트너」, 「레이블리 대행」, 「총판」, 「독점」, 「지사」, 「직영」, 「대리점」처럼 회사를 대리하거나 회사와 동일한 지위에 있는 것으로 오인하게 하는 표현을 쓸 수 없습니다(공통 약관 제8조 3호·4호).",
        "3. 파트너는 마크 옆에 「계약 체결·조건 확약 권한 없음」과 같은 한계를 표시할 수 있으며, 회사가 요청하면 표시해야 합니다.",
      ].join("\n")],
      ["C-4조 (쓸 수 있는 곳)", [
        "1. 명함의 앞면 또는 뒷면.",
        "2. 이메일 서명.",
        "3. 회사 소개나 작품·크리에이터 소개를 위한 제안서·소개서의 표지와 첫 장.",
        "4. 파트너센터에 등록한 홍보 채널(부속 B B-4조 7항)의 소개란.",
        "5. 오프라인 행사의 배너·명패.",
        "6. 그 밖에 회사가 파트너 가이드에서 허용한 곳.",
      ].join("\n")],
      ["C-5조 (쓸 수 없는 곳과 금지되는 변형)", [
        "1. SNS 계정의 프로필 사진으로 쓸 수 없습니다.",
        "2. 파트너 자신의 로고·앱 아이콘과 결합해 하나의 표장처럼 쓸 수 없고, 파트너의 상호·상품명·도메인 이름에 「레이블리」 또는 「Laeebly」를 넣을 수 없습니다.",
        "3. 계산서·견적서·계약서 등 거래 문서에 쓸 수 없습니다.",
        "4. 파트너센터에 등록하지 않은 채널과 회사가 홍보를 금지한 사이트에 쓸 수 없습니다.",
        "5. 한 면(한 페이지·한 화면)에 마크를 둘 이상 두거나, 파트너 자신의 로고보다 크게 둘 수 없습니다.",
        "6. 마크의 색·모양·비율을 바꾸거나, 회전하거나, 그림자 같은 효과를 더하거나, 문구를 번역·수정하거나, 파트너 코드·발급 연도를 고치거나 지울 수 없습니다.",
        "7. 마크를 따라 그리거나 비슷한 표장을 만들어 쓸 수 없습니다.",
      ].join("\n")],
      ["C-6조 (발급과 유효 기간)", [
        "1. 마크는 파트너 코드가 활성화된 파트너에게만 발급됩니다. 파트너센터 자료실이 파트너 코드와 발급 연도를 그림에 넣어 만듭니다.",
        "2. 그림 파일의 마크는 그림에 표시된 연도의 12월 31일까지 유효합니다. 그 뒤에는 자료실에서 다시 받은 파일만 사용합니다.",
        "3. 붙여넣기 코드의 마크는 회사 서버가 그리며, 파트너의 자격 상태에 따라 자동으로 바뀝니다. 파트너는 이를 가리거나 다른 그림으로 바꿔 넣을 수 없습니다.",
      ].join("\n")],
      ["C-7조 (자격 상실과 회수)", [
        "1. 파트너 코드가 정지되거나 파트너 계약이 해지·종료되면 마크 사용 허락은 그 즉시 끝납니다.",
        "2. 파트너는 온라인에 게시한 마크를 48시간 안에 삭제하고, 인쇄물은 7일 안에 폐기한 뒤 회사에 알립니다. 삭제·폐기가 늦어 생긴 손해는 파트너가 부담합니다.",
        "3. 파트너가 이 문서를 위반하면 회사는 사용 허락을 언제든 철회하고 게시 중단과 폐기를 요구할 수 있으며, 위반이 중대하면 공통 약관 제14조에 따라 파트너 계약을 해지할 수 있습니다.",
      ].join("\n")],
      ["C-8조 (경제적 이해관계의 표시)", [
        "1. 파트너가 후기·추천·사용법 소개처럼 추천·보증의 형태로 레이블리를 소개하면서 파트너 링크나 파트너 코드를 안내하는 경우, 「추천·보증 등에 관한 표시·광고 심사지침」에 따라 회사와의 경제적 이해관계를 게시물의 제목 또는 첫 부분에 명확하게 표시합니다(공통 약관 제8조 8호).",
        "2. 마크를 붙였다는 것만으로는 제1항의 표시를 한 것으로 보지 않습니다. 회사는 파트너 가이드에서 표시 문구의 예를 안내합니다.",
      ].join("\n")],
      ["C-9조 (확인과 사칭 신고)", [
        "1. 회사는 마크의 진위를 확인할 수 있는 확인 페이지를 운영할 수 있으며, 파트너는 상대방이 이를 통해 확인하는 것에 협조합니다.",
        "2. 파트너는 다른 사람이 회사 또는 파트너를 사칭하거나 마크를 무단으로 쓰는 것을 알게 되면 지체 없이 회사에 알립니다.",
      ].join("\n")],
      ["부칙", "이 부속은 2026년 10월 1일부터 시행합니다."],
    ],
    checks: [
      { key: "body", label: "부속 C 본문(C-1조~C-9조)을 읽고 동의합니다." },
      { key: "no_authority", label: "마크는 「등록된 파트너」라는 사실만 표시하며, 회사를 대리하거나 계약·조건을 확약할 권한을 뜻하지 않음(C-1조·C-3조)을 이해했습니다." },
      { key: "revoke", label: "자격을 잃으면 온라인 게시물은 48시간 안에 삭제하고 인쇄물은 7일 안에 폐기하겠습니다(C-7조)." },
    ],
  },
];
